/**
 * @generated SignedSource<<024f0ad5119ae649d7a6212de5e57722>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNewsfeedPost_widgetNewsfeedPost$data = {
  readonly body: string | null;
  readonly date: string | null;
  readonly images: ReadonlyArray<{
    readonly id: string;
    readonly largeImage: {
      readonly height: number;
      readonly url: string;
      readonly width: number;
    } | null;
  }>;
  readonly title: string | null;
  readonly " $fragmentType": "WidgetNewsfeedPost_widgetNewsfeedPost";
};
export type WidgetNewsfeedPost_widgetNewsfeedPost$key = {
  readonly " $data"?: WidgetNewsfeedPost_widgetNewsfeedPost$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNewsfeedPost_widgetNewsfeedPost">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNewsfeedPost_widgetNewsfeedPost",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": "largeImage",
          "args": [
            {
              "kind": "Literal",
              "name": "minHeight",
              "value": 1080
            },
            {
              "kind": "Literal",
              "name": "minWidth",
              "value": 1080
            }
          ],
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "size",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": "size(minHeight:1080,minWidth:1080)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    }
  ],
  "type": "WidgetNewsfeedPost",
  "abstractKey": null
};

(node as any).hash = "c3941ad002950282328fe239ed938fd5";

export default node;
